import React from 'react';

const Announcement = () => {
  return (
    <div className="previewTile">
      <div className="featureTitle">Has Science Gone Too Far?</div>
      <div className="announcement">
        Megarubigram lovers rejoice: The <a href="/ultrarubigram">Ultrarubigram</a> lives. Due to its Herculean difficulty, this puzzle will only run once a month.
      </div>
      {/* <div className="announcement">Today's morphology by Trip Payne is a cryptic, clued in the style of cryptic crosswords. If you've never solved a cryptic before, here's a <a target="_blank" href="https://www.newyorker.com/puzzles-and-games-dept/cryptic-crossword/reintroducing-the-new-yorkers-cryptic-crossword">written guide</a> from the New Yorker and also their <a target="_blank" href="https://www.youtube.com/watch?v=HrKiYFJxgic">video guide</a>, both with instructions and information on how the clueing works. The WSJ also wrote a concise <a target="_blank" href="https://s.wsj.net/blogs/html/wsjcrypticguide.pdf">PDF</a> on the subject.</div>
      <div className="announcement">We'll be leaving this puzzle up over the weekend to give solvers extra time to work on it. Enjoy!</div> */}
      {/* <div className="breakingNewsLabel">Breaking News:</div>
      <div className="featureTitle">MOBILE APPS NOW AVAILABLE</div>
      <div className="announcement">Free for both <a href="https://apps.apple.com/app/id6755982312">iOS</a> and <a href="https://play.google.com/store/apps/details?id=com.dailybaffle.mobile">Android</a>!</div> */}
    </div>
  );
};

export default Announcement;
